import { isAPP } from "@environment/type";

export function getVersionNumber() {
    if (isAPP()) {
        return new Promise((resolve) => {
            cordova.getAppVersion.getVersionNumber().then((version) => {
                resolve(version)
            });
        });
    }
}


export default {
    getVersionNumber
}